export { FroalaViewDirective } from './froalaview.directive';
export { FroalaViewModule } from './froalaview.module';